module.exports = __webpack_public_path__ + "images/5df90e8920b86b1927e641b562097ea93555136c28652da97df1fb8fdc5e5c94.svg";